import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledVaccinatedSyringeIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 40 40",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			width: 40,
			height: 40,
			rx: 12,
			fill: "#E6F7F1"
		}),
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_29798_50464)",
			children: [
				/* @__PURE__ */ _jsx("path", {
					d: "M22 30L30 22",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M13.7071 17.7071L24 28L28 24L17.7071 13.7071C17.3166 13.3166 16.6834 13.3166 16.2929 13.7071L13.7071 16.2929C13.3166 16.6834 13.3166 17.3166 13.7071 17.7071Z",
					fill: "white",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M20.5 24.5L22.5 22.5",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M18.5 22.5L20.5 20.5",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M16.5 20.5L18.5 18.5",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M12 14L14 16L16 14L14 12L12 14Z",
					fill: "white",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M9 9L13 13",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M28 30L25 27L27 25L30 28L28 30Z",
					fill: "#33BF8D",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M27 31L31 27",
					stroke: "#008355",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				}),
				/* @__PURE__ */ _jsx("circle", {
					cx: 27,
					cy: 13,
					r: 4.25,
					fill: "#008355",
					stroke: "#008355",
					strokeWidth: 1.5
				}),
				/* @__PURE__ */ _jsx("path", {
					d: "M25 13L26.5 14.5L29 12",
					stroke: "white",
					strokeLinecap: "round",
					strokeLinejoin: "round"
				})
			]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_29798_50464",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white",
				transform: "translate(8 8)"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgFilledVaccinatedSyringeIcon);
const Memo = memo(ForwardRef);
export default Memo;
